<!--
================================================
Un composant affichant une modale utilisable dans 2 modes :

- mode limit :  lorsqu'un utilisateur non premium tente d'utiliser
une fonction premium et invit à upgrade

- confirmTrialStart : Affiche une confirmation pour démarrer le free trial

Url d'accès :
http://localhost:8080/fr/sega-inc/sega-workspace/subscription?cycle=month&pgr=fr-3ertuixp

LIMITATION DU COMPOSANT :
================================================
-->
<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

  <div class="modal" id="ModalPremiumLimitationComp" v-bind:class="[{ 'darkMode':themeToDisplay=='dark','is-active': isVisible }]" v-on:keyup.esc="hideModal()">
        <!--ajouter la classe is-active sur.modal pour l'afficher-->
        <div class="modal-background"></div>


        <div  class="modal-card" >
            <header class="modal-card-head has-background-white is-justify-content-flex-end  ">

                <button v-on:click="hideModal()" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body pt-1 pb-6">

              <img v-if="mode=='confirmTrialStart'"
                   class="m-auto mb-4 is-block trialIllustration"
                  src="../assets/img/illustrations/Market-launch-amico.svg"
                  alt="illustration"
                  height="200px"
                  width="200px" />

              <img v-else-if="mode=='limit'"
                   class="m-auto mb-4 is-block limitIllustration"
                  src="../assets/img/illustrations/Press-pause-amico.svg"
                  alt="illustration"
                  height="200px"
                  width="200px" />

              <h2 class="is-size-4 has-text-dark-grey mt-4 mb-3 has-text-secondary has-text-centered">{{title}}</h2>
              <p class="has-text-centered has-text-grey">
                <span class="msg " v-html="message"></span>
                <span class="c2aMsg " v-html="c2a"></span>

              </p>
            </section>

            <!--------------------------------------------------------->
            <footer class="modal-card-foot">

              <router-link v-if="mode=='limit'" id="" class="button validBtn" v-bind:to="{ name: 'workspace-subscription',params:{locale:locale,organization:organizationSlug, workspace:$auth.getActiveWorkspace()},query:{cycle:'month',pgr:planGroup4Locale}}">
                <span>{{ $t('MettreÀNiveau') }}</span>
                <font-awesome-icon class="icon ml-1 is-size-7" :icon="['fas', 'medal']"/>
              </router-link>

              <button v-else-if="mode=='confirmTrialStart'" v-bind:disabled="isSubmiting"  v-bind:class="{'is-loading':isSubmiting}"  class="button validBtn " v-on:click="isSubmiting=true, $root.$emit('trial_start_confirmed',priceIdSource)">
                <span>{{ $t('DémarrerMaintenant') }}</span>
                <font-awesome-icon class="icon ml-1 is-size-7" :icon="['fas', 'medal']"/>
              </button>

                <a v-on:click="hideModal()" class="button is-text cancelLink" >{{$t("plusTard")}}</a>
            </footer>

        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import i18nMixin from "@/mixins/i18nMixin";

    export default {
        name: 'ModalPremiumLimitationComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, i18nMixin],
        components: {},

        props: {
        },
        data: function () {
            return {
                // name: 'foobar' , // string @todo customize

                locale : this.$route.params.locale,
                isVisible: false, // bool | la visibilité de la modale
                isSubmiting : false, // indique si le composant est en cours de soumission (par exemple lors du démarrage de la subscription trial)
                mode: null, // String le mode pour afficher la modale (confirmTrialStart => pour confirmer le démarrage d'un trial | limit => pour afficher des limitations)
                title: this.$t('LimiteAtteinte')+'...', // string le titre à afficher dans la modale (surchargeable)
                message: this.$t('CetteFonctionalitéNestPasAccessible'), // string le message à afficher dans la modale (surchargeable)
                c2a: this.$t('CetteFonctionalitéNestPasAccessible'), // string le message call 2 action à afficher dans la modale (surchargeable)
              priceIdSource: null, // Un priceId Stripe (la valeurs de priceIdForCycle depuis PlanBLoc) sert à identifier quel plan doit PlanBloc doit démarrer une trial subscription

                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user
                organization: state => state.organization,
                themeToDisplay: state => state.app.themeToDisplay

            }),


        },
        watch: {
        },


        methods: {

            /*
            * Affiche la modale
            */
            showModal(){
                this.isVisible = true
            },

            /*
            * Masque la modale
            */
            hideModal(){
                this.isVisible = false
                this.isSubmiting=false
            },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            /**
             * Event show_modal_bootstrap, déclenche l'affichage de la modale
             * @param mode (le mode d'affichage 'limit'|'confirmTrialStart')
             * @param title Titre de la modale
             * @param message Message de la modale
             * @param c2a Message call to action de la modale
             * @param priceIdSource le priceId  qui a déclenché l'affichage de la modale
             */
            this.$root.$on('show_modal_premium_limitation', (mode,title, message, c2a, priceIdSource = null) => {
              this.mode= mode,
              this.title = title
              this.message = message
              this.c2a = c2a,
              this.priceIdSource = priceIdSource
              this.showModal()
            })


          /*
           * Event hide_modal_bootstrap, masque la modale
           */
            this.$root.$on('hide_modal_bootstrap', () => {
                this.hideModal()
            })



        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #ModalPremiumLimitationComp{

      z-index: 100; // la modale doit pouvoir passer par dessus d'autre modale eventuellement
      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////

      .modal-card{
        .msg{
          ::v-deep b {color: $brandThird !important;}
        }
        .c2aMsg{
          display: block;
          ::v-deep b {color: $brandPremium !important;}
        }
      }
      footer{
        .validBtn {
          color: $brandThird;
          .icon{color: $brandPremium;}
          &.is-loading{
            .icon{
              color: transparent;
            }
          }
        }
      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        .modal-card-head {background-color: $darkBg !important;}
        .modal-card{

          h2 {color: $brandPrimary !important;}
          p {color: $darkTxt !important;

            .smile{color: $darkLightBlue;}
          }
          .msg{
            ::v-deep b {color: $darkContrastTxt !important;}

          }


        }
        .validBtn{
          background-color: $darkBg2 !important;
          color: $darkContrastTxt !important;
          &.is-loading{
            color: transparent !important;

          }
        }
        .cancelLink{
          color: #666 !important;
        }
      }

    }



</style>
